// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3iFjQ","rootSuccess":"CompleteLink_rootSuccess__2Qdfi","rootFailure":"CompleteLink_rootFailure__-qsYR","isDisabled":"CompleteLink_isDisabled__3gbPt"};